// Platform-level theme tokens — the single source of truth for the Meridian
// (Equinox) brand palette, typography, status tones and motion timings.
//
// History: the constants lived at app/lib/collections-simulator/theme.ts and
// this file only re-exported them. Since Phase 1 of the 2026-09-18 design
// review the constants live HERE and that file re-exports from this one, so
// its 54 importers keep working unchanged. Add new tokens here only.
//
// Mirror of the CSS variables in app/globals.css (`--eq-*`). Keep both in sync.

export const BRAND = {
  navy: '#091525',
  navyDeep: '#091525',
  navyMid: '#152A42',
  gold: '#DFC06A',
  goldDeep: '#C7A84F',
  goldSoft: '#F0D89C',
  text: '#1A1A1A',
  text2: '#5A6B7D',
  text3: '#8899AA',
  border: '#D4D8DE',
  borderLight: '#E5E8ED',
  bg: '#ECEEF1',
  card: '#FFFFFF',
  cardSoft: '#F8F9FB',
  cream: '#FFFBEB',
  green: '#0F7B57',
  greenSoft: '#D1FAE5',
  red: '#B91C1C',
  redSoft: '#FEE2E2',
  // Payer-type accents
  commercial: '#1A56DB',
  commercialSoft: '#E8F0FE',
  government: '#92400E',
  governmentSoft: '#FEF3E0',
  selfPay: '#6B21A8',
  selfPaySoft: '#F3E8FF',
  other: '#4B5563',
  otherSoft: '#F3F4F6',
} as const

export const FONT_BODY =
  "'Source Sans 3', 'Helvetica Neue', Helvetica, Arial, sans-serif"
export const FONT_SERIF = "Georgia, 'Times New Roman', serif"

export const PAYER_TYPE_CHIP: Record<string, { bg: string; fg: string }> = {
  commercial: { bg: BRAND.commercialSoft, fg: BRAND.commercial },
  government: { bg: BRAND.governmentSoft, fg: BRAND.government },
  'self-pay': { bg: BRAND.selfPaySoft, fg: BRAND.selfPay },
  other: { bg: BRAND.otherSoft, fg: BRAND.other },
}

/** Status tones — navy and gold only (Mark, 2026-09-18). No red, no green. */
export const STATUS = {
  good: { bg: 'rgba(9,21,37,0.06)', fg: BRAND.navy },
  attention: { bg: 'rgba(223,192,106,0.14)', fg: BRAND.goldDeep },
  muted: { bg: 'rgba(136,153,170,0.14)', fg: BRAND.text2 },
  critical: { bg: BRAND.navy, fg: '#FFFFFF' },
  neutral: { bg: 'transparent', fg: BRAND.text2 },
} as const
export type StatusTone = keyof typeof STATUS

/** Motion language — durations in ms; transform and opacity only. */
export const MOTION = {
  fast: 150,
  base: 220,
  slow: 300,
  arrival: 1900,
  easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
  easeOut: 'ease-out',
} as const
